import Service from './service';
import { getMarketingContent } from './marketingContent.query';

const Config = require('Config');

export type ProductTeaser = {
  _id: string,
  product: string,
  marketingType: string,
  web: ProductTeaserContent
};

export interface ProductTeaserContent {
  headerImage: string,
  marketingUrl: string,
  buttonText: string,
  infoCards: InfoCard[],
  additionalProps: ProductTeaserAdditionalProps
}

export interface InfoCard {
  title: string,
  body: string,
  icon: string,
}

export interface ProductTeaserAdditionalProps {
  ourServices: {
    headerText: string,
    bodyText: string,
  }
}

export class MarketingContentService extends Service {
  constructor() {
    super(Config.marketingContentServiceUrl);
  }

  async getMarketingContent(product: string, marketingType: string): Promise<ProductTeaser> {
    const url = `/`;

    const body = {
      ...getMarketingContent,
      variables: {
        product,
        marketingType,
      },
    };

    const response = await this.axios.post<{ getMarketingContent: ProductTeaser}>(url, body);
    if (!response || response.status !== 200) {
      throw new Error();
    }
    return response.data.getMarketingContent;
  }
}

export default new MarketingContentService();
